import { render, staticRenderFns } from "./DeleteDatabaseUserDialog.vue?vue&type=template&id=a2105b10&"
import script from "./DeleteDatabaseUserDialog.vue?vue&type=script&lang=ts&"
export * from "./DeleteDatabaseUserDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports